import { TimePicker } from 'antd'
import styled from 'styled-components'

const TimePickerStyled = styled(TimePicker)`
  width: 170px;
`

export default TimePickerStyled
